//#region Libraries
import { useRef } from "react";
//#endregion
//#region Components
import ManagementAvailability from "../Popups/ManagementAvailability/ManagementAvailability";
import AppointmentData from "../Popups/AppointmentData/AppointmentData";
import PresentialFooter from "../Popups/AppointmentData/Footers/PresentialFooter/PresentialFooter";
import RemoteFooter from "../Popups/AppointmentData/Footers/RemoteFooter/RemoteFooter";
import ReservationsPaginator from "./ReservationsPaginator/ReservationsPaginator";
//#endregion
//#region Utils
import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
//#endregion
//#region Icons
import AttendedIcon from "icons/AttendedIcon";
import useUpdateActivityPopup from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopup";
import AppointmentScheduleActivityCard from "views/Asesorias/components/AppointmentScheduleActivityCard";
import { HOUR_IN_MINUTES } from "utils/time";
import SessionPopup from "../../../SchedulesComponent/components/Session/SessionPopup";
//#endregion

const QUANTITY_CELLS_PER_CARD = 4;

const ScheduleActivity = ({
    title, subtitle,
    dateTimeData,
    inactivity, reservation,
    footerData,
    adviser, filteringByStudent,
    reloadData,
    classList = [],
    isAdviser, isPast, isPresential, 
    appointmentId,
    nextOrBackReservationPage,
    isBoss
}) => {
    const $activity = useRef();
    const updateActivityPopup = useUpdateActivityPopup({
        $activity, isPast
    });
    //#region Functions
    const isShiftCard = () => {
        return classList.some((item) => ["inactivity", "available"].includes(item));
    }
    const changesCannotBeDone = () => {
        const timeMinutesAppointment = dateTimeData.hour*HOUR_IN_MINUTES;
        let minutesOfNow = getMinutesOfToday();
        let dateToday = getTodayWithoutHourInMillis();
        const result = (
            dateToday > dateTimeData.date || 
            (dateToday === dateTimeData.date && minutesOfNow >= timeMinutesAppointment)
        );
        return result;
    }
    const getIsTimeAppointment = () => {
        const timeMinutesAppointment = dateTimeData.hour*HOUR_IN_MINUTES;
        let dateToday = getTodayWithoutHourInMillis();
        let minutesOfNow = getMinutesOfToday();
        const isTime = (
            dateTimeData.date === dateToday && 
            minutesOfNow >= timeMinutesAppointment && 
            minutesOfNow < timeMinutesAppointment + HOUR_IN_MINUTES
        );
        return isTime;
    }
    //#endregion
    const isTimeAppointment = getIsTimeAppointment();

    return (
        <td rowSpan={QUANTITY_CELLS_PER_CARD}>
            <SessionPopup
                updateActivityPopup={updateActivityPopup}
                variant={isShiftCard() ? "availability" : "reservation-detail"}>
                {isShiftCard() 
                ? (
                    !isAdviser && 
                    <ManagementAvailability 
                        dateTimeData={dateTimeData}
                        inactivity={inactivity}
                        available={classList.includes("available")}
                        reloadData={reloadData}
                        adviser={adviser}
                        changesCannotBeDone={changesCannotBeDone}
                        showUpdateDialog={updateActivityPopup.popup.value}/>
                )
                : <AppointmentData
                    title={title}
                    subtitle={subtitle}
                    dateTimeData={dateTimeData}
                    reservation={reservation}
                    isPresential={isPresential}
                    reloadData={reloadData}
                    appointmentId={appointmentId}
                    isAdviser={isAdviser}
                    isTimeAppointment={isTimeAppointment}
                    changesCannotBeDone={changesCannotBeDone}
                    showUpdateDialog={updateActivityPopup.popup.value}
                    >
                    {isPresential 
                    ? <PresentialFooter data={footerData.place}/>
                    : <RemoteFooter 
                        isTimeAppointment={isTimeAppointment} 
                        zoom={footerData.zoom}/>}
                  </AppointmentData>}
            </SessionPopup>
            <AppointmentScheduleActivityCard
                classList={classList}
                activity={$activity}
                superheader={filteringByStudent && 
                    <ReservationsPaginator 
                        quantity={reservation.quantity} 
                        isPast={isPast}
                        nextOrBackReservationPage={nextOrBackReservationPage}/>}
                header={{
                    title, subtitle
                }}
                dialogUpdate={updateActivityPopup.popup}
                quantityCells={QUANTITY_CELLS_PER_CARD}
                icon={typeof reservation?.attended === "boolean" && (
                    <AttendedIcon 
                        className="icon"
                        attended={reservation.attended}/>
                )}
                isBoss={isBoss}/>
        </td>
    );
}

export default ScheduleActivity;
